import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import numbro from 'numbro';

import { SVGIconType } from '../../../../constants/svgIcon';
import { Account, Profile } from '../../../../models/UserStore';
import {
  AppBar,
  AvatarNode,
  ListItemProps,
  SettingList,
  SvgIcon,
} from '../../../Molecules';

import styles from './AccountTemplate.module.css';

type AccountTemplateProps = {
  profile: Profile | undefined;
  account: Account | undefined;
  accountListData: ListItemProps[];
  walletListData: ListItemProps[];
  logoutListData: ListItemProps[];
};

export const AccountTemplate = memo(
  ({
    profile,
    accountListData,
    walletListData,
    logoutListData,
    account,
  }: AccountTemplateProps) => {
    const { t } = useTranslation();

    return (
      <div className={styles.container}>
        <AppBar
          leading={
            <SvgIcon
              name={SVGIconType.Setting}
              width={28}
              height={28}
              color={'#333'}
            />
          }
          title={t('Account')}
        />
        <div className={styles.account}>
          {/* <p className={styles.textTitle}>{t('Account')}</p> */}
          {profile && <AvatarNode profile={profile} size={140} />}

          <div className={styles.nameEmailContainer}>
            {profile && <p className={styles.profileName}>{profile.name}</p>}
            {account && (
              <p className={styles.accountEmail}>{account.email?.address}</p>
            )}
          </div>

          {profile && (
            <div className={styles.outterBarContainer}>
              <div className={styles.wisdomLevel}>
                <span className={styles.wisdomLevelText}>
                  {t('Wisdom Level: ')}
                </span>
                <span>{`Lv.${profile.exp.level}`}</span>
              </div>
              <div className={styles.barContainer}>
                <div
                  className={styles.blackLayerText}
                >{`Lv.${profile.exp.level}`}</div>
                <div className={styles.progressBarGrey}>
                  <div
                    className={styles.progress}
                    style={{ width: `${profile.exp.progress * 100}%` }}
                  />
                </div>
              </div>
              <p className={styles.nextExp}>
                {`${numbro(profile.exp.totalNextLevelRequirement).format({
                  thousandSeparated: true,
                })} XP`}
              </p>
              <div className={styles.totalExp}>
                {t('Total: {n} Wisdom XP', {
                  n: numbro(profile.exp.total).format({
                    thousandSeparated: true,
                  }),
                })}
              </div>
            </div>
          )}

          <div className={styles.centeredContainer}>
            <div className={styles.settingList}>
              <SettingList data={accountListData} />
            </div>
          </div>

          <br />

          <div className={styles.centeredContainer}>
            <div className={styles.settingList}>
              <SettingList data={walletListData} />
            </div>
          </div>

          <br />

          <div className={styles.centeredContainer}>
            <div className={styles.settingList}>
              <SettingList data={logoutListData} />
            </div>
          </div>
        </div>
      </div>
    );
  },
);
